module.exports = __webpack_public_path__ + "static/img/rs_js_13.033449b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_13.png
// module id = 0Xzh
// module chunks = 1